import { Link } from "react-router-dom";

/**
 * Shared chrome for the static legal pages (Terms, Privacy). Keeps both pages
 * visually consistent and constrains the reading column for legibility inside
 * the app's max-w-7xl main region.
 *
 * These are plain-language, standard-template documents for a SaaS that
 * operates via OAuth sign-in and crawls user-supplied web apps. They are a
 * reasonable starting point — have legal counsel review before relying on them.
 */
export function LegalLayout(props: {
  title: string;
  updated: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <div className="mx-auto max-w-3xl">
      <Link to="/" className="text-sm text-slate-400 hover:text-white">
        ← Back to UAIP
      </Link>
      <h1 className="mt-4 text-3xl font-bold text-slate-100">{props.title}</h1>
      <p className="mt-1 text-sm text-slate-500">Last updated: {props.updated}</p>
      <div className="mt-8 space-y-8 text-sm leading-relaxed text-slate-300">
        {props.children}
      </div>
      <footer className="mt-12 border-t border-slate-800 pt-6 text-xs text-slate-500">
        UAIP is a product of NNG IT Solutions. Questions? Email{" "}
        <a className="text-slate-300 hover:text-white" href="mailto:info@uaip.dev">
          info@uaip.dev
        </a>
        .
      </footer>
    </div>
  );
}

export function LegalSection(props: {
  heading: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <section>
      <h2 className="text-lg font-semibold text-slate-100">{props.heading}</h2>
      <div className="mt-2 space-y-3">{props.children}</div>
    </section>
  );
}
